import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.rip = bracketIndenting({
	line: "#",
})
